import {observable, action, runInAction} from 'mobx'
import {get, json} from "../../../utils/ajax"
import {handleSearchAndPage,ValueObjToObj,setStore} from "../../../utils/Utils";
import {message} from 'antd'

class SparePartsPertainToAudiStore{
    @observable loading
    @observable pagination
    @observable searchFields
    @observable list
    @observable formatMessage
    @observable carseriesList
    @observable okJumpArg

    constructor(){
        this.loading=false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:10,
            showTotal:()=>`总共 0 条`
        }
        this.searchFields={
            spareNo:'',
            materialCode:'',
        }
        this.list=[]
        this.carseriesList=[]
        this.formatMessage=()=>{}
        this.okJumpArg=''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore=(obj)=>{
        setStore(obj,this)
    }

    /**
     * 将页面的值绑到store
     * @param changedFields
     */
    @action
    onFieldsChange=(changedFields)=>{
        this.searchFields={...this.searchFields,...ValueObjToObj(changedFields)}
    }

    /**
     * 查询车系
     */
    @action
    initCarSeriesList = async () => {
            this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseries:search`)
        runInAction(() => {
            this.carseriesList = Array.isArray(res) ? res : []
            this.loading = false
        })
    };

    /**
     * 初始化页面
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initPage=async (page)=>{
        // if(!this.searchFields.carseriesCode){
        //     message.warning(this.formatMessage({id: 'ConfigureQuery.carseriesCode'}))
        //     return
        // }
        if(!this.searchFields.spareNo&&!this.searchFields.materialCode){
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseEnterTheSearchCriteria'}))
            return
        }
        this.loading = true
        let search = handleSearchAndPage(page, this.pagination, this.searchFields);
        search.isBackend=0
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/config/sparePartsBelongToTheCarSeries/getPage:search`,search);
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(()=>{
            this.list=res.content||[]
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 重置表单
     * @returns {Promise<void>}
     */
    @action
    clearSearch= ()=>{
        this.searchFields={
            spareNo:'',
            materialCode:'',
        }
        this.list=[]
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:10,
            showTotal:()=>{}
        }
    }


    /**
     * 能不能跳转
     */
    @action
    okJump = async (carseriesCode) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/config/sparePartsQroupJumpControl?carseriesCode=${carseriesCode}`)
        return res.msg
    };


}

export default new SparePartsPertainToAudiStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/SparePartsPartainToAudi/store.js